import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Paper,
  alpha,
} from '@mui/material';
import { FaNodeJs } from "react-icons/fa";
import { SiMongodb } from "react-icons/si";
import BaseTab from './BaseTab';

interface BackendTechStackTabProps {
  isDark: boolean;
  colors: any;
  discordFont: any;
  glassStyle: any;
  lokiGradient: string;
  goldColor: string;
  isMobile: boolean;
}

const BackendTechStackTab: React.FC<BackendTechStackTabProps> = (props) => {
  return (
    <BaseTab
      {...props}
      title="Backend Tech Stack"
      emoji="🛠"
    >
      <Typography variant="h6" sx={{ color: props.goldColor, mb: 3 }}>
        Backend Technology Stack
      </Typography>
      
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Card sx={{ height: '100%', borderLeft: `4px solid ${props.goldColor}` }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <FaNodeJs size={30} color={props.goldColor} />
                <Box sx={{ ml: 2 }}>
                  <Typography variant="h6" fontWeight={700} color={props.colors.textPrimary}>
                    Runtime & Framework
                  </Typography>
                  <Typography variant="caption" color={props.colors.textSecondary}>
                    Node.js + Express.js with TypeScript
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid size={{ xs: 12, md: 6 }}>
          <Card sx={{ height: '100%', borderLeft: `4px solid #0F3B2E` }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <SiMongodb size={30} color="#0F3B2E" />
                <Box sx={{ ml: 2 }}>
                  <Typography variant="h6" fontWeight={700} color={props.colors.textPrimary}>
                    Database
                  </Typography>
                  <Typography variant="caption" color={props.colors.textSecondary}>
                    MongoDB with Mongoose ODM
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, color: props.goldColor }}>
          Core Dependencies
        </Typography>
        <Grid container spacing={2}>
          {[
            { name: 'Passport.js', desc: 'Authentication', color: props.goldColor },
            { name: 'WebSocket (ws)', desc: 'Real-time', color: '#0F3B2E' },
            { name: 'Pinata SDK', desc: 'IPFS Storage', color: '#1D5C4A' },
            { name: 'bcryptjs', desc: 'Security', color: props.goldColor },
            { name: 'JWT', desc: 'Tokens', color: '#0F3B2E' },
            { name: 'Multer', desc: 'File Uploads', color: '#1D5C4A' },
          ].map((dep, idx) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={idx}>
              <Paper sx={{ p: 2, borderLeft: `4px solid ${dep.color}` }}>
                <Typography variant="subtitle2" fontWeight={700} sx={{ color: dep.color }}>
                  {dep.name}
                </Typography>
                <Typography variant="caption" color={props.colors.textSecondary}>
                  {dep.desc}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </BaseTab>
  );
};

export default BackendTechStackTab;